import { fetchCSRFToken } from "../csrf";

/**
 * Take a `button` or `a` and, on click, allow the default event to propagate
 * or create a form with `props.action` (and optionally `props.method`) and
 * submit it.
 */
export default function confirmAction(el, props) {
  var question = props.question;

  function onClick(e) {
    e.preventDefault();

    var confirmed = question === undefined ? true : window.confirm(question);

    if (confirmed) {
      var input;
      var formMethod = props.method === "GET" ? "GET" : "POST";

      var form = document.createElement("form");
      form.setAttribute("method", formMethod);
      form.setAttribute("action", props.action);
      form.style.display = "none";

      if (props.method !== "GET") {
        fetchCSRFToken().then(csrfToken => {
          input = document.createElement("input");
          input.setAttribute("type", "hidden");
          input.setAttribute("name", "_csrf");
          input.setAttribute("value", csrfToken);
          form.appendChild(input);
          document.querySelector("body").appendChild(form);
          form.submit();
        });
      }

      if (props.method === "PUT" || props.method === "DELETE") {
        input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "_method");
        input.setAttribute("value", props.method === "PUT" ? "put" : "delete");
        form.appendChild(input);
      }
    }
  }

  el.addEventListener("click", onClick);
}
